import React from 'react';
import GeoPageTemplate from '../components/GeoPageTemplate';
import geoConfigs from '../config/geoConfigs';

const LocacaoMinasGerais = () => {
  return <GeoPageTemplate {...geoConfigs.minasgerais} />;
};

export default LocacaoMinasGerais;